import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.734 6.949a.75.75 0 0 0-.75.748 2.25 2.25 0 0 1-2.25 2.247h-3.75v-.936a.563.563 0 0 0-.94-.417L2.17 10.276a.56.56 0 0 0 0 .834l1.875 1.684a.56.56 0 0 0 .606.096.56.56 0 0 0 .333-.513v-.936h3.75c2.068 0 3.75-1.68 3.75-3.744a.75.75 0 0 0-.75-.748m-7.5-2.995h3.73l.02.936a.563.563 0 0 0 .542.561c.136 0 .271-.05.376-.144l1.875-1.685a.53.53 0 0 0 .207-.438.53.53 0 0 0-.186-.418L8.923 1.082a.57.57 0 0 0-.605-.096c-.202.112-.355.313-.355.534l.021.936h-3.75A3.75 3.75 0 0 0 .484 6.2a.75.75 0 0 0 1.5 0 2.25 2.25 0 0 1 2.25-2.246" }, null, -1)
  ]))]))
}
export default { render: render }